"use client";

import { authClient } from "@/lib/auth-client";
import { cn } from "@/lib/utils";

export function FooterLogoutButton({ className }: { className?: string }) {
  return (
    <button
      onClick={() =>
        authClient.signOut({
          fetchOptions: {
            onSuccess: () => {
              window.location.href = "/login";
            },
          },
        })
      }
      className={cn(
        "text-xs transition-colors",
        className ?? "text-white/30 hover:text-white/60",
      )}
    >
      Cerrar sesión
    </button>
  );
}
